"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _ui = require("@unite-us/ui");
var _components = require("./components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var InlineEditField = /*#__PURE__*/function (_Component) {
  _inherits(InlineEditField, _Component);
  var _super = _createSuper(InlineEditField);
  function InlineEditField(props) {
    var _this;
    _classCallCheck(this, InlineEditField);
    _this = _super.call(this, props);
    _this.onEditClick = _this.onEditClick.bind(_assertThisInitialized(_this));
    _this.onCancelEdit = _this.onCancelEdit.bind(_assertThisInitialized(_this));
    _this.onSaveEdit = _this.onSaveEdit.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.setFieldRef = _this.setFieldRef.bind(_assertThisInitialized(_this));
    _this.validate = _this.validate.bind(_assertThisInitialized(_this));
    _this.componentRef = null;
    _this.state = {
      editMode: false,
      localValue: props.value,
      isSaving: false,
      fieldMeta: {
        valid: true,
        invalid: false,
        touched: false,
        pristine: true,
        dirty: false,
        visited: false,
        error: ''
      }
    };
    return _this;
  }
  _createClass(InlineEditField, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        this.setState({
          localValue: nextProps.value
        });
      }
    }
  }, {
    key: "onEditClick",
    value: function onEditClick() {
      var onFieldEdit = this.props.onFieldEdit;
      this.setState({
        editMode: true
      }, this.validate);
      onFieldEdit();
    }
  }, {
    key: "onCancelEdit",
    value: function onCancelEdit(event) {
      event.preventDefault();
      var _this$props = this.props,
        value = _this$props.value,
        onFieldCancel = _this$props.onFieldCancel;
      this.setState({
        editMode: false,
        localValue: value,
        fieldMeta: _objectSpread(_objectSpread({}, this.state.fieldMeta), {}, {
          dirty: false,
          pristine: true,
          touched: false,
          visited: false
        })
      }, this.validate);
      onFieldCancel();
    }
  }, {
    key: "onSaveEdit",
    value: function onSaveEdit(event) {
      var _this2 = this;
      event.preventDefault();
      var _this$props2 = this.props,
        onFieldSave = _this$props2.onFieldSave,
        onFieldError = _this$props2.onFieldError;
      var _this$state = this.state,
        localValue = _this$state.localValue,
        fieldMeta = _this$state.fieldMeta;
      this.setState({
        fieldMeta: _objectSpread(_objectSpread({}, this.state.fieldMeta), {}, {
          touched: true,
          visited: true
        })
      });
      if (fieldMeta.valid) {
        var result = onFieldSave(localValue);
        if (result instanceof Promise) {
          this.setState({
            isSaving: true
          });
          return result.then(function () {
            _this2.setState({
              isSaving: false,
              editMode: false
            });
          });
        }
        return this.setState({
          editMode: false
        });
      }
      return onFieldError(fieldMeta.error);
    }
  }, {
    key: "onChange",
    value: function onChange(event) {
      var onFieldChange = this.props.onFieldChange;
      var value = (0, _lodash.get)(event, 'target.value', event);
      this.setState({
        localValue: value,
        fieldMeta: _objectSpread(_objectSpread({}, this.state.fieldMeta), {}, {
          dirty: true,
          pristine: false
        })
      }, this.validate);
      onFieldChange(value);
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      var onFieldBlur = this.props.onFieldBlur;
      this.setState({
        fieldMeta: _objectSpread(_objectSpread({}, this.state.fieldMeta), {}, {
          touched: true,
          visited: true
        })
      }, this.validate);
      onFieldBlur();
    }
  }, {
    key: "setFieldRef",
    value: function setFieldRef(ref) {
      this.componentRef = ref;
    }
  }, {
    key: "validate",
    value: function validate() {
      var fieldValidations = this.props.fieldValidations;
      var localValue = this.state.localValue;
      var error;
      if ((0, _lodash.isFunction)(fieldValidations)) {
        error = fieldValidations(localValue);
      } else if ((0, _lodash.isArray)(fieldValidations)) {
        var errors = (0, _lodash.map)(fieldValidations, function (validation) {
          return validation(localValue);
        });
        error = (0, _lodash.join)((0, _lodash.compact)(errors), ', ');
      }
      if (this.componentRef && (0, _lodash.isFunction)(this.componentRef.validate)) {
        var _errors = this.componentRef.validate(localValue);
        error = (0, _lodash.join)((0, _lodash.compact)([error, _errors]), ', ');
      }
      this.setState({
        fieldMeta: _objectSpread(_objectSpread({}, this.state.fieldMeta), {}, {
          error: error,
          valid: (0, _lodash.isEmpty)(error),
          invalid: !(0, _lodash.isEmpty)(error)
        })
      });
      return error;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        afterLabelContent = _this$props3.afterLabelContent,
        disabled = _this$props3.disabled,
        className = _this$props3.className,
        displayValue = _this$props3.displayValue,
        fieldComponent = _this$props3.fieldComponent,
        fieldProps = _this$props3.fieldProps,
        id = _this$props3.id,
        label = _this$props3.label,
        value = _this$props3.value;
      var _this$state2 = this.state,
        editMode = _this$state2.editMode,
        fieldMeta = _this$state2.fieldMeta,
        isSaving = _this$state2.isSaving,
        localValue = _this$state2.localValue;
      var containerClass = function containerClass() {
        return (0, _classnames["default"])({
          'ui-inline-edit-field': true
        }, className);
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: containerClass(),
        id: id
      }, (!editMode || disabled) && /*#__PURE__*/_react["default"].createElement(_components.Display, {
        afterLabelContent: afterLabelContent,
        id: id,
        label: label,
        onEditClick: this.onEditClick,
        value: !(0, _lodash.isNil)(displayValue) ? displayValue : value,
        disabled: disabled
      }), editMode && !disabled && /*#__PURE__*/_react["default"].createElement(_components.EditField, {
        afterLabelContent: afterLabelContent,
        FieldComponent: fieldComponent,
        fieldMeta: fieldMeta,
        fieldProps: fieldProps,
        id: id,
        isSaving: isSaving,
        label: label,
        onBlur: this.onBlur,
        onCancelEdit: this.onCancelEdit,
        onChange: this.onChange,
        onSaveEdit: this.onSaveEdit,
        setFieldRef: this.setFieldRef,
        value: localValue
      }));
    }
  }]);
  return InlineEditField;
}(_react.Component);
InlineEditField.propTypes = {
  /** Content to display after the label in the display/ edit views */
  afterLabelContent: _propTypes["default"].node,
  /** ClassName passed to the wrapper div */
  className: _propTypes["default"].string,
  /** Is edition disabled */
  disabled: _propTypes["default"].bool,
  /** Value string used for display if different from `value` */
  displayValue: _propTypes["default"].string,
  /** ID of the component */
  id: _propTypes["default"].string.isRequired,
  /** Field component to render in the edit mode */
  fieldComponent: _propTypes["default"].func,
  /** Props passed directly to the fieldComponent */
  fieldProps: _propTypes["default"].object,
  /** Validation function(s) to run against the fieldComponent */
  fieldValidations: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].array]),
  /** Label to display */
  label: _propTypes["default"].string.isRequired,
  /** Field blur callback */
  onFieldBlur: _propTypes["default"].func,
  /** Cancel callback */
  onFieldCancel: _propTypes["default"].func,
  /**
   * Field change callback
   * @param value
   */
  onFieldChange: _propTypes["default"].func,
  /** Edit button callback */
  onFieldEdit: _propTypes["default"].func,
  /**
   * Called when the invalid field is saved
   * @param {string} error
   */
  onFieldError: _propTypes["default"].func,
  /**
   * Called when the valid field is saved.
   * If this returns a Promise, the component will wait for the resolve to switch back to display mode
   * @param value
   */
  onFieldSave: _propTypes["default"].func.isRequired,
  /** Value of the field */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].object])
};
InlineEditField.defaultProps = {
  afterLabelContent: null,
  className: '',
  disabled: false,
  displayValue: undefined,
  fieldComponent: _ui.InputField,
  fieldProps: {},
  fieldValidations: undefined,
  onFieldBlur: _lodash.noop,
  onFieldCancel: _lodash.noop,
  onFieldChange: _lodash.noop,
  onFieldEdit: _lodash.noop,
  onFieldError: _lodash.noop,
  value: ''
};
var _default = exports["default"] = InlineEditField;